import Vue from 'vue'
import Router from 'vue-router'
import Home from "../components/Home";
import Login from "../components/Login";
import RecordList from "../components/RecordList";
import Report from "../components/Report";
import cookie from "../service/cookie";
import ProjectList from '../components/ProjectList.vue';
// 移动端组件
import MLogin from '../components/mobile/MLogin.vue';
import MHome from '../components/mobile/MHome.vue';
import MOrder from '../components/mobile/MOrder.vue';
import MProject from '../components/mobile/MProject.vue';
import MMine from '../components/mobile/MMine.vue';
import MReport from '../components/mobile/MReport.vue';
import MPwd from '../components/mobile/MPwd.vue';
import MAgreement from '../components/mobile/MAgreement.vue';
import pub from '../service/public';

Vue.use(Router)

// 根路径占位组件：实际渲染由 beforeEach 用 replace 重定向接管，不会真正渲染
const Blank = { render: h => h('div') }
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 设备检测函数
function isMobileDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const width = window.innerWidth;
  // 通过 User Agent 和屏幕宽度判断是否为移动端
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent) || width <= 768;
}

// 移动端路由 <-> PC 路由 显式映射
// 注意：数据/项目并非 1:1 命名（移动端 /m/order 对应 PC /recordList），必须显式映射，
// 否则设备切换时按字符串拼接得到 /order、/project 等不存在的路由，导致空白页。
const ROUTE_MAP = {
  // 移动端 -> PC
  '/m/home': '/home',
  '/m/order': '/recordList',
  '/m/project': '/projectList',
  '/m/mine': '/home',     // PC 端无个人中心独立页，落到首页
  '/m/pwd': '/home',
  '/m/report': '/report',   // 报告查看：PC 端有独立查看页
  // PC -> 移动端（与上面一一对应，保证分享链接双向适配）
  '/report': '/m/report',
  '/home': '/m/home',
  '/recordList': '/m/order',
  '/projectList': '/m/project'
};
// 取移动端对应的 PC 路由；无显式映射时回退到「去掉 /m 前缀」
function toPCRoute(path) {
  return ROUTE_MAP[path] || (path.replace('/m', '') || '/home');
}
// 取 PC 对应的移动端路由；无显式映射时回退到「加 /m 前缀」
function toMobileRoute(path) {
  return ROUTE_MAP[path] || ('/m' + path);
}

const vueRouter = new Router({
  mode:'history',
  routes: [
    {
      // 根路径由 beforeEach 用 replace 重定向接管，避免历史栈残留 '/' 导致后退跳回登录页
      path: '/',
      component: Blank
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {path:'/home',component:Home,name:'home' },   //首页
    {path:'/recordList',component:RecordList,name:'recordList'},   //数据记录
    {path:'/projectList',component:ProjectList,name:'projectList'},   //项目列表
    {path:'/report',component:Report,name:'Report'},   //PC端查看报告（与移动端 /m/report 双向适配）
    // 移动端路由
    {path:'/m/login',component:MLogin,name:'MLogin'},
    {path:'/m/home',component:MHome,name:'MHome',meta:{requireAuth:true}},
    {path:'/m/order',component:MOrder,name:'MOrder',meta:{requireAuth:true}},
    {path:'/m/project',component:MProject,name:'MProject',meta:{requireAuth:true}},
    {path:'/m/mine',component:MMine,name:'MMine',meta:{requireAuth:true}},
    {path:'/m/report',component:MReport,name:'MReport'},
    {path:'/m/pwd',component:MPwd,name:'MPwd',meta:{requireAuth:true}},
    {path:'/m/agreement',component:MAgreement,name:'MAgreement'}
  ]
});
vueRouter.beforeEach((to, from, next) => {
  // 已登录用户不应再看到登录页：拦截 /login 与 /m/login，replace 到对应首页
  // 解决浏览器后退时若历史栈中残留登录页，会重新显示登录页的问题
  if ((to.path === '/login' || to.path === '/m/login') && pub.isLoggedIn()) {
    next({ path: to.path.startsWith('/m/') ? '/m/home' : '/home', replace: true });
    return;
  }

  // 根路径：根据设备与登录态重定向，使用 replace 避免历史栈残留 '/' 导致后退又跳登录页
  if (to.path === '/') {
    let isMobile = sessionStorage.getItem('isMobile') === 'true';
    if (!sessionStorage.getItem('isMobile')) {
      isMobile = isMobileDevice();
      sessionStorage.setItem('isMobile', isMobile ? 'true' : 'false');
    }
    const target = pub.isLoggedIn()
      ? (isMobile ? '/m/home' : '/home')
      : (isMobile ? '/m/login' : '/login');
    next({ path: target, replace: true });
    return;
  }

  // 移动端路由守卫
  // 注意：微信 WebView 在切后台回收页面后重新加载时 sessionStorage 会被清空，
  // 因此这里在缺失时回退到设备检测，避免把 /m/* 误判为 PC 路由而跳错页面。
  let isMobile = sessionStorage.getItem('isMobile') === 'true';
  if (!sessionStorage.getItem('isMobile')) {
    isMobile = isMobileDevice();
    sessionStorage.setItem('isMobile', isMobile ? 'true' : 'false');
  }
  const isMobileRoute = to.path.startsWith('/m/');
  const isPCRoute = !isMobileRoute && to.path !== '/';

  if (isMobile && isPCRoute) {
    // 移动端访问PC路由，跳转到对应的移动端路由（用映射表，避免 /order 等不存在的路由）
    // 保留 query / hash，否则分享链接里的参数（如报告 id）会丢失
    const target = toMobileRoute(to.path);
    next({ path: target, query: to.query, hash: to.hash });
    return;
  }

  if (!isMobile && isMobileRoute) {
    // PC端访问移动端路由，跳转到对应的PC路由（用映射表，/m/order -> /recordList）
    // 保留 query / hash，否则分享链接里的参数（如报告 id）会丢失
    const target = toPCRoute(to.path);
    next({ path: target, query: to.query, hash: to.hash });
    return;
  }

  // 报告查看页（分享链接）免登录：移动端与 PC 端均允许未登录直接访问，且不受后续 requireAuth 守卫影响
  if (to.path === '/m/report' || to.path === '/report') {
    next();
    return;
  }

  // 登录守卫：移动端路由统一要求登录态（cookie 存在即可）
  if (to.matched.some((r) => r.meta.requireAuth)) {
    if (pub.isLoggedIn()) {
      next();
    } else {
      next(isMobile ? '/m/login' : '/login');
    }
    return;
  }

  next();
});

// 百度统计：每次路由切换后触发统计
vueRouter.afterEach((to) => {
  if (typeof umami !== 'undefined') {
    umami.trackView(to.fullPath);
  }
});

export default vueRouter;



// WEBPACK FOOTER //
// ./src/router/index.js